import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Target, Star, ChatCenteredText } from "@phosphor-icons/react";
import { GoalTracker } from "./GoalTracker";
import { Appraisals } from "./Appraisals";
import { Feedback360 } from "./Feedback360";

export function PerformanceDashboard() {
  const [activeTab, setActiveTab] = useState("goals");

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="flex flex-col gap-2">
        <h2 className="text-2xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-slate-900 to-slate-700 dark:from-white dark:to-slate-300">
          Performance Management
        </h2>
        <p className="text-slate-500 dark:text-slate-400">
          Track goals, manage appraisals, and share feedback.
        </p>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-3 lg:w-auto">
          <TabsTrigger value="goals" className="gap-2">
            <Target className="w-4 h-4" />
            <span className="hidden md:inline">Goals & OKRs</span>
          </TabsTrigger>
          <TabsTrigger value="appraisals" className="gap-2">
            <Star className="w-4 h-4" />
            <span className="hidden md:inline">Appraisals</span>
          </TabsTrigger>
          <TabsTrigger value="feedback" className="gap-2">
            <ChatCenteredText className="w-4 h-4" />
            <span className="hidden md:inline">360° Feedback</span>
          </TabsTrigger>
        </TabsList>

        <div className="mt-6">
          <TabsContent value="goals" className="space-y-4">
            <GoalTracker />
          </TabsContent>

          <TabsContent value="appraisals" className="space-y-4">
            <Appraisals />
          </TabsContent>

          <TabsContent value="feedback" className="space-y-4">
            <Feedback360 />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
}
